import wx from 'weixin-js-sdk'

// 跳转小程序
export function linkWx(data) {
  let goMethod = 'navigateTo'
  const { instance, url, base64, imgPath, params } = data

  // 小程序中页面栈最多十层 当到达十层时需要更改跳转方法为 'reLaunch' 防止页面栈溢出 无法跳转后续页面
  // 由于首页不需要返回上一层页面 所以也需讲方法改为 'reLaunch'
  if (window.WxPages >= 10 || url === '/pages/Home') goMethod = 'reLaunch'

  if (Object.keys(data).length <= 1) {
    wx.miniProgram[goMethod]({
      url: `${url}`
    })
    return
  }
  let info = encodeURIComponent(
    JSON.stringify({
      instance
    })
  )
  wx.miniProgram[goMethod]({
    // url: `${url}?info=${info}&base64=${base64}&imgPath=${imgPath}`
    url: `${url}?info=${info}&imgPath=${imgPath}&params=${params}`
  })
}
